import { Component, OnInit } from '@angular/core';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DataEntityMainService } from 'src/app/Service/DataEntity/DataEntityMain.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-CertificateFormList',
  templateUrl: './CertificateFormList.component.html',
  styleUrls: ['./CertificateFormList.component.scss']
})
export class CertificateFormListComponent implements OnInit {

  Token:String=""
  Switcher_View:String="List"
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private DataEntityMain_Service:DataEntityMainService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
  ) { }


  Certificate_List:Array<General_Interface>=[]
  Data_Seleted_Select:General_Interface=Empty_General_Interface()

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,1148).subscribe(
      data=>{
        this.ReadData_Certificate()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }

  ReadData_Certificate(){
    this.Procssing=true
    this.DataEntityMain_Service.GetDataEntity(this.Token).subscribe(
      data=>{
        this.Certificate_List = data['certificate']


        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  ShowForm(item: General_Interface)
  {
    this.Data_Seleted_Select = item
    this.Switcher_View="Form"
  }

  Back_From_Form()
  {
    this.Data_Seleted_Select = Empty_General_Interface()
    this.Switcher_View="List"
  }

}
